export const BEEHIVE_QUERY_KEY = 'beehive-search';
